import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { init } from './firebase-config';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {

  componentWillMount() {
    init()
  }

  render() {
    // let route;
    // if (window.location.pathname === "/" || window.location.pathname === "/users" ||
    //   window.location.pathname === "/payment-history" || window.location.pathname === "/users/:id") {
    //   console.log("window.location.pathname", window.location.pathname)
    //   route = (<div>
    //     <Route exact path="/" name="Login Page" render={props => <Login {...props} />} />
    //     <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
    //     <Route path="/:id" name="Home" render={props => <TheLayout {...props} />} />
    //   </div>)
    // } else {
    //   route = (<div>
    //     <Route path={window.location.pathname} name="Page 404" render={props => <Page404 {...props} />} />
    //   </div>)
    // }
    return (
      <Router>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/" name="Login Page" render={props => <Login {...props} />} />
            <Route path="/500" name="Page 500" render={props => <Page500 {...props} />} />
            <Route path="/home" name="Home" render={props => <TheLayout {...props} />} />
            <Route exact path="/*" name="Page 404" render={props => <Page404 {...props} />} />
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;
